import { API_ENDPOINTS } from "@/api/services/helpdesk/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const myRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchMyRequestPending: builder.query({
      query: () => ({
        url: API_ENDPOINTS.MYREQUEST.FETCH_MYREQUEST_PENDING,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "myRequest", id: "LIST" }],
    }),
    fetchMyRequestCompleted: builder.query({
      query: () => ({
        url: API_ENDPOINTS.MYREQUEST.FETCH_MYREQUEST_COMPLETED,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "myRequest", id: "LIST" }],
    }),

    reopenTicket: builder.mutation({
      query: ({ id, formData }) => ({
        url: API_ENDPOINTS.MYREQUEST.REOPEN_REQUEST(id),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "myRequest", id: "LIST" }],
    }),
    feedbackSubmit: builder.mutation({
      query: ({ id, data }) => ({
        url: API_ENDPOINTS.MYREQUEST.FEEDBACK_SUBMIT(id),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [{ type: "myRequest", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchMyRequestPendingQuery,
  useFetchMyRequestCompletedQuery,
  useReopenTicketMutation,
  useFeedbackSubmitMutation,
} = myRequestApi;
